
/** 
 * Casts an object to a specific class type.
 * @param {any} object - The object to cast.
 * @param {any} classType - The class type to cast the object to.
 * @returns {any} - The casted object.
 * @throws {Error} - If the object cannot be cast to the specified class type.
 */
function cast(object, classType) {
    if (object instanceof Object) {
        return object;
    }
    throw new Error(`Object cannot be cast to type ${classType.name}`);
}

export { cast };